export default {
    title: '<strong>선생님</strong>과 <strong>학생</strong>이 함께 참여하는 <strong>실시간 수업 활동</strong>',
    buttons: {
        teacher: '선생님 수업하기',
        student: '학생 입장하기',
    },
};
